class FullWidthVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger () {
    this.els.video.elements.forEach(video => {
      if(video.style.display != 'none'){
        video.play()
        video.setAttribute('controls', true)
        this.els.trigger.element.style.display = 'none'
      }
    })
  }
}

if (!customElements.get('full-width-video')) {
  customElements.define('full-width-video', FullWidthVideo)
}